import { render, staticRenderFns } from "./projectTab.vue?vue&type=template&id=689df0b0&"
import script from "./projectTab.vue?vue&type=script&lang=js&"
export * from "./projectTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports